import React, { Suspense } from 'react'

import { ListSkeleton } from '@/components/ListSkeleton'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import ErrorPage from '@/pages/Error'
import { Divider, Skeleton, Stack, Typography } from '@mui/material'
import { WalletTabHeader } from './parts/WalletTabHeader'
import { PaymentList } from './parts/PaymentList'

const WalletTab: React.FC = () => {
  return (
    <ErrorBoundary fallback={<ErrorPage />}>
      <Suspense
        fallback={
          <Stack direction="column" width="100%" spacing={2}>
            <Skeleton variant="rounded" width="100%" height={68} sx={{ borderRadius: 3 }} />
            <Skeleton variant="rounded" width="100%" height={76} sx={{ borderRadius: 2 }} />
            <Divider sx={{ my: 1 }} />
            <Skeleton variant="rounded" width="50%" height={24} sx={{ borderRadius: 2 }} />
            <ListSkeleton.Wrapper count={3}>
              <ListSkeleton.PaymentItem />
            </ListSkeleton.Wrapper>
          </Stack>
        }
      >
        <Stack direction="column" width="100%" spacing={2}>
          <WalletTabHeader />
          <Divider sx={{ my: 1 }} />
          <Typography variant="subtitle1" fontWeight="bold">
            Histórico de transações
          </Typography>
          <PaymentList />
        </Stack>
      </Suspense>
    </ErrorBoundary>
  )
}

export default WalletTab
